module.exports = __webpack_public_path__ + "img/logo-indesign.989e107d.png";